import { render, staticRenderFns } from "./AddSupervisionUserModal.vue?vue&type=template&id=3f1a704a&"
import script from "./AddSupervisionUserModal.vue?vue&type=script&lang=js&"
export * from "./AddSupervisionUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports